module.exports = __webpack_public_path__ + "img/alerts-4-mobile.f0eac31c.gif";